import { FC, useEffect, useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import { useRemoveDetailsPlotGroup } from '@/components/PlotGroups/PlotGroupsContextProvider';
import { usePathSet } from '@/hooks/usePathSet';
import { useAuth } from '@/lib/auth';

export const PlotGroupDetailsCleaner: FC = () => {
  const { isSignedIn } = useAuth();

  return isSignedIn ? <PlotGroupDetailsChecker /> : null;
};

const PlotGroupDetailsChecker: FC = () => {
  const pathSet = usePathSet();
  const { removeDetailsPlotGroup } = useRemoveDetailsPlotGroup();
  const { pathname } = useLocation();

  const routesWithDetailsPlotGroups = useMemo(
    () => [
      pathSet.details,
      pathSet.plotGroupPlots,
      pathSet.impactProjections,
      pathSet.impactProjectionsV2,
      pathSet.plot,
      pathSet.biodiversityDetails,
      pathSet.soilDetails,
      pathSet.waterDetails,
      pathSet.deforestationDetails,
      pathSet.forestDetails,
      pathSet.carbonDetails,
      pathSet.socialDetails,
    ],
    [pathSet],
  );

  useEffect(() => {
    const isDetailsPlotGroupRoute = routesWithDetailsPlotGroups.some((allowedRoute) =>
      matchPath(allowedRoute, pathname),
    );

    if (!isDetailsPlotGroupRoute) {
      removeDetailsPlotGroup();
    }
  }, [pathname, removeDetailsPlotGroup, routesWithDetailsPlotGroups]);

  return null;
};
